import FormDynamicNewsFilter from './FormCollectionsFilter';



export default FormDynamicNewsFilter;
